/**
 * An account in the chart — docs/22 §2, one field per column with a reader.
 *
 * "Every column below has a reader, or it does not ship." The reader of each
 * field is named beside it; gate 17 (docs/19 §3b) is the test that the reader
 * exists. A declared flag nothing consults reads exactly like one that works,
 * which is how oplus posted hand journals into header accounts for years.
 */
export function accountId(value) {
    return value;
}
/** Which side an account of each kind normally sits on. Derived, and checked against the stored side. */
export const NORMAL_SIDE = {
    asset: "debit",
    liability: "credit",
    equity: "credit",
    income: "credit",
    expense: "debit",
};
//# sourceMappingURL=account.js.map